import { mc } from '@styles';
import React, { FC, useState } from 'react';

import ChevronDown from './assets/chevron-down.inline.svg';

export type PostSortType = 'RECENT_ASC' | 'RECENT_DESC' | 'ALPHABET_ASC' | 'ALPHABET_DESC';

export interface SortItem {
  type: PostSortType;
  label: string;
}

interface Props {
  onChange: (type: PostSortType) => void;
  selected?: PostSortType;
}

export const SortByDropdown: FC<Props> = ({ selected, onChange }) => {
  const [visible, setVisible] = useState<boolean>(false);

  const types: SortItem[] = [
    {
      type: 'RECENT_DESC',
      label: 'Most recent first',
    },
    {
      type: 'RECENT_ASC',
      label: 'Most recent last',
    },
    {
      type: 'ALPHABET_ASC',
      label: 'A to Z',
    },
    {
      type: 'ALPHABET_DESC',
      label: 'Z to A',
    },
  ];

  const handleSortItemClick = (item: SortItem) => {
    onChange(item.type);
    setVisible(false);
  };

  return (
    <div className="relative flex flex-col justify-center items-center shrink-0">
      <a
        onClick={() => setVisible(!visible)}
        role="button"
        className="hover:text-accent-orange hover:fill-accent-orange fill-ocean-blue flex flex-row items-center text-ocean-blue font-sharp font-semibold"
      >
        Sort By <ChevronDown />
      </a>

      {visible && (
        <ul
          className={mc(
            'top-0 left-0 z-10 absolute',
            'min-w-[220px]',
            'mt-8',
            'border border-light-gray rounded-lg',
            'overflow-hidden bg-white shadow-lg font-medium text-sm',
          )}
        >
          {types.map(itm => (
            <li key={itm.label} className={mc('hover:bg-light-gray cursor-pointer', selected === itm.type && 'bg-light-gray')}>
              <a role="button" className="py-1 px-6 hover:text-accent-orange block" onClick={() => handleSortItemClick(itm)}>
                {itm.label}
              </a>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default SortByDropdown;
